import AntdButton from 'components/atom/Buttons/AntdButton'
import ModalLayout from 'components/modal/ModalLayout'

interface DeleteCaseRecordModalProps {
  caseRecordId: number
  isModalVisible: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
}

export const DeleteCaseRecordModal = ({
  caseRecordId,
  isModalVisible,
  onClose,
  onConfirm,
  loading,
}: DeleteCaseRecordModalProps) => {
  if (!isModalVisible) return null
  return (
    <ModalLayout>
      <div className='mt-4'>
        <div className='text-black text-2xl font-bold'>
          Are you sure you want to delete Case Record #{caseRecordId}?
        </div>
        <div className='mt-2 mb-7 text-textColor text-base font-normal'>
          This Case Record will be permanently deleted. You can create a new Case Record later.
        </div>
      </div>

      <div className='mt-7 flex justify-end gap-8'>
        <AntdButton
          text='Cancel'
          className='h-12 w-full bg-white text-red border-red hover:!bg-white hover:!text-red'
          onClick={onClose}
        />
        <AntdButton
          text='Delete'
          className='h-12 !bg-red w-full hover:!bg-red'
          onClick={() => {
            if (loading) return
            onConfirm()
          }}
          loading={loading}
          disabled={loading}
        />
      </div>
    </ModalLayout>
  )
}
